import React from 'react';
import { Box, Stack } from '@chakra-ui/react';
import { useForgotPassword, useTimer } from 'hooks';
import { useTranslation } from 'localization';

import {
  AuthSuggestion,
  DesktopAuthHeader,
  SERVICE_CARD_BORDER_RADIUS,
} from 'components';

import { Form } from './components';

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation('component.auth.forgotPassword');
  const { counter, setCounter } = useTimer(0);

  const { mutateAsync: submit, isPending: isSubmitting } = useForgotPassword();

  return (
    <Stack w="100%" align="stretch" gap={{ base: 6, md: 8 }}>
      <DesktopAuthHeader title={t('reset')} titleAlign="center" />
      <Box
        bg="dark"
        borderWidth="1px"
        borderColor="rgba(255,255,255,0.08)"
        borderRadius={SERVICE_CARD_BORDER_RADIUS}
        px={{ base: 5, md: 7 }}
        py={{ base: 6, md: 8 }}
        w="100%"
      >
        <Form
          isSubmitting={isSubmitting}
          onButton={(data) =>
            submit(data).then(() => {
              setCounter(120);
            })
          }
          counter={counter}
        />
      </Box>
      <AuthSuggestion include={['sign-in', 'sign-up']} />
    </Stack>
  );
};

export default ForgotPassword;
